import styled from '@emotion/styled';

const GroupName = styled('h4')({
  fontWeight: 400,
});

export default GroupName;
